import throttle from 'lodash/throttle'
import { useEffect, useMemo, useState } from 'react'

export const useScrollPoint = (point: number = 0) => {
  const [isPoint, setIsPoint] = useState(false)

  const setPointHeader = useMemo(
    () =>
      throttle(() => {
        const isReachPoint = window.scrollY > point
        if (isReachPoint !== isPoint) setIsPoint(isReachPoint)
      }, 300),
    [isPoint, point]
  )

  useEffect(() => {
    window.addEventListener('scroll', setPointHeader)

    return () => {
      window.removeEventListener('scroll', setPointHeader)
    }
  }, [isPoint, setPointHeader])

  return { isPoint }
}
